import React, { useEffect, useRef, useState } from 'react';
import { RefreshCw, Check, Volume2, VolumeX } from 'lucide-react';
import { CLIMATES, CLIMATE_IDS } from './scene/Weather';

// Round button showing the current weather; opens a menu to pick a climate or "Auto".
const ClimateControl = ({ mode, climate, localWeather, onChange, autoSeconds, soundOn, onToggleSound }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  const choose = (value) => { onChange(value); setOpen(false); };
  const item = 'w-full flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-amber-50 text-left';

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        className="h-10 w-10 rounded-full bg-white/90 shadow-md hover:bg-amber-100 flex items-center justify-center text-lg relative"
        title={`Weather: ${CLIMATES[climate].label}${mode === 'auto' ? ' (auto)' : ''}`}
      >
        <span>{CLIMATES[climate].icon}</span>
        {mode === 'auto' && (
          <span className="absolute -bottom-0.5 -right-0.5 h-4 w-4 rounded-full bg-amber-600 text-white flex items-center justify-center">
            <RefreshCw size={9} />
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-12 top-0 w-52 bg-white/95 backdrop-blur-sm rounded-lg shadow-xl border p-1 z-50">
          <div className="px-3 pt-2 pb-1 text-xs font-semibold uppercase tracking-wider text-gray-500">Climate</div>
          <button className={item} onClick={() => choose('auto')}>
            <RefreshCw size={16} className="text-amber-700" />
            <span className="flex-1">
              Auto
              <span className="block text-[11px] text-gray-500">
                {localWeather
                  ? `Started with the weather${localWeather.place ? ` in ${localWeather.place}` : ' where you are'} (${CLIMATES[localWeather.climate].label.toLowerCase()}), then changes at random`
                  : 'Changes on its own, at random'}
              </span>
            </span>
            {mode === 'auto' && <Check size={16} className="text-amber-700" />}
          </button>
          <div className="my-1 border-t" />
          {CLIMATE_IDS.map((id) => (
            <button key={id} className={item} onClick={() => choose(id)}>
              <span className="w-4 text-center">{CLIMATES[id].icon}</span>
              <span className="flex-1">{CLIMATES[id].label}</span>
              {mode === id && <Check size={16} className="text-amber-700" />}
            </button>
          ))}
          {onToggleSound && (
            <>
              <div className="my-1 border-t" />
              <button className={item} onClick={onToggleSound}>
                {soundOn ? <Volume2 size={16} className="text-amber-700" /> : <VolumeX size={16} className="text-gray-400" />}
                <span className="flex-1">Weather sounds</span>
                <span className={`text-xs font-medium ${soundOn ? 'text-amber-700' : 'text-gray-400'}`}>{soundOn ? 'On' : 'Off'}</span>
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ClimateControl;
